module.exports = __webpack_public_path__ + "img/threat-analytics-alerts.c44cbf23.png";